import {MODALS_CLOSE, MODALS_OPEN, MODALS_WINDOW_RESIZE} from "./ModalsConstants";

const initialState = {
  opened: false,
  modalType: null,
  windowSize: {
    height: window.document.documentElement.clientHeight,
    width: window.document.documentElement.clientWidth
  },
  content: {
    messageModal: {
      title: null,
      message: null,
      type: null
    }
  }
};

export function modals(state = initialState, action) {
  switch (action.type) {
    case MODALS_CLOSE:
      return {
        ...state,
        opened: false,
        modalType: null
      };
    case MODALS_OPEN:
      console.log('OPEN ACTION, ', action);
      return {
        ...state,
        opened: true,
        modalType: action.modalType,
        content: action.content
      };
    case MODALS_WINDOW_RESIZE:
      return {
        ...state,
        windowSize: action.action
      };
    default:
      return state;
  }
}

export const getModalsState = state => {
  return state.modals;
};



// WEBPACK FOOTER //
// ./src/common/modals/ModalsReducer.js